/**
 * Global motion preference. Honors the OS "reduce motion" setting unless the
 * player overrides it in Settings.
 */
class MotionPrefs {
  private override: boolean | null = null;
  private readonly media = window.matchMedia('(prefers-reduced-motion: reduce)');

  constructor() {
    this.media.addEventListener('change', () => this.apply());
    this.apply();
  }

  get reduced(): boolean {
    return this.override ?? this.media.matches;
  }

  setOverride(v: boolean | null): void {
    this.override = v;
    this.apply();
  }

  private apply(): void {
    document.documentElement.classList.toggle('reduced-motion', this.reduced);
  }
}

export const motion = new MotionPrefs();
